import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={1} height={24} viewBox="0 0 1 24" fill="none" {...props}>
      <Path stroke="#fff" strokeDasharray="1 1" d="M.5 0v24" />
    </Svg>
  );
}

export default SvgComponent;
